import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ClienteAnaliseMercadoRevisaoSearch } from '../../adapters';

@Component({
    selector: 'sgt-cliente-analise-mercado-revisao-form-info',
    templateUrl: './cliente-analise-mercado-revisao-form-info.component.html',
    styleUrls: ['./cliente-analise-mercado-revisao-form-info.component.less']
})
export class ClienteAnaliseMercadoRevisaoFormInfoComponent {
    @Input() revisao: ClienteAnaliseMercadoRevisaoSearch;
}
